const iconMap = new Map();
iconMap.set('侦察预警机', { img: 'air-default', iconSize: [32, 40], });
iconMap.set('运输机', { img: 'air-default', iconSize: [32, 35], });
iconMap.set('加油机', { img: 'air-default', iconSize: [32, 35], });
iconMap.set('战斗机', { img: 'air-default', iconSize: [32, 47], });
iconMap.set('轰炸机', { img: 'air-default', iconSize: [32, 27], });
iconMap.set('直升机', { img: 'air-default', iconSize: [32, 40], });
iconMap.set('浮空器', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('货运飞机', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('NASA', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('Adversary Support(Aggressor)', { img: 'air-default', iconSize: [32, 35], });
iconMap.set('Adversary Support(transport)', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('情报收集', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('空军一号', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('Hurricane Hunters', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('Virgin Orbit', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('美国51区', { img: 'air-default', iconSize: [32, 32], });
iconMap.set('个人拥有', { img: 'air-default', iconSize: [32, 24], });
iconMap.set('公司团体', { img: 'air-default', iconSize: [32, 32], });

iconMap.set('两栖攻击舰', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('两栖舰', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('侦察测绘', { img: 'ship-default', iconSize: [12, 30], });
iconMap.set('巡洋舰', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('护卫舰', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('海警船', { img: 'ship-default', iconSize: [14, 32], });
iconMap.set('潜艇', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('航母', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('运输补给', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('驱逐舰', { img: 'ship-default', iconSize: [10, 30], });
iconMap.set('石油运输船队', { img: 'ship-default', iconSize: [32, 32], });
iconMap.set('拖船', { img: 'ship-default', iconSize: [26, 32], });

export const AirOrShipIcon = (type, iconSize) => {
  if (iconMap.has(type)) {
    let target = iconMap.get(type);
    return L.icon({
      iconUrl: require(`@/assets/icon/marker/${target.img}.png`),
      iconSize: iconSize || target.iconSize,
      iconAnchor: (iconSize || target.iconSize).map(e => { return e / 2 }),
    })
  }
  return undefined;
}
